import React, { Component } from 'react';
import './App.css';
import { Provider } from "react-redux";
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import { ConfigProvider, theme } from 'antd';

import store from './store';
import ShellRoot from './ShellRoot';
import Message from './components/Message';
import NewIncidentForm from './modules/incidents/components/NewIncidentForm';
import KycGrid from './modules/KYC/components/KycGrid';

class App extends Component {

  constructor(props) {
    super(props);
    this.store = store;
  };

  render() {
    return (
      <Provider store={this.store}>
        <ConfigProvider theme={
          {
          algorithm: theme.defaultAlgorithm,
          token: {
            colorPrimary: "#0091dc",
            colorError: "#ff6e0a",
            borderRadius: 0,
            wireframe: false,
            fontSize: 14,
          },
          components: {
            Layout: {
              siderBg: '#0091dc',
              colorBgContainer: '#0091dc',
            },
            Menu: {
              darkItemBg: '#0091dc',
              darkSubMenuItemBg: '#0091dc',
              darkItemColor: '#ffffff',
              darkItemHoverColor: '#ffffff',
              darkItemSelectedColor: '#ffffff',
              darkItemSelectedBg: '#00aef7',
              itemBg: "#0091dc",
              subMenuItemBg: '#0091dc',
              itemColor: "#FFFFFF",
              colorPrimary: "#ffffff",
              itemHoverColor: "#FFFFFF",
              itemSelectedBg: "#00aef7",
              horizontalItemSelectedBg: "#0091dc",
              itemSelectedColor: "#ffffff",
              groupTitleColor: "#ffffff",
              collapsedWidth: 60,
              colorBgContainer: "#0091dc",
              colorBgElevated: '#0091dc'
            },
            Tooltip: {
              colorBgDefault: "#0091dc"
            },
            Modal: {
              colorTextHeading: "#0091dc"
            },
            Popover: {
              colorTextHeading: "#0091dc"
            },
          }
        }
        }>
        <BrowserRouter>
          <div className='AppRoot'>
            <Switch>
              {/* volgorde belangrijk... */}
              <Route path="/details" component={Message} />
              <Route path="/incident" component={NewIncidentForm} />
              <Route path="/kyc" component={KycGrid} />
              {/* als niet bekend dan de shell laden */}
              <Route path="/app" component={ShellRoot} />
              <Redirect to='/app' from='/' />
            </Switch>
          </div>
        </BrowserRouter>
        </ConfigProvider>
      </Provider>
    );
  }
}

export default App;